import { render, staticRenderFns } from "./accessory-goods-part.vue?vue&type=template&id=b0e0806a&"
import script from "./accessory-goods-part.vue?vue&type=script&lang=js&"
export * from "./accessory-goods-part.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports